import { useCallback, useMemo } from 'react'
import { matchRoutes, useLocation } from 'react-router-dom'

export const useCurrentPath = (routes: { path: string }[]) => {
  const location = useLocation()

  const routeDetail = useCallback(() => {
    const route = matchRoutes(routes, location)
    // @ts-ignore
    const [{ pathname = '', params }] = route || [{}]
    const { path = '', id = '', customerId } = params || {}
    return {
      id,
      path,
      pathname,
      customerId: customerId === 'customer' ? undefined : customerId,
    }
  }, [location, routes])

  return useMemo(() => routeDetail(), [routeDetail])
}
